import { Phone, Mail, MapPin, Facebook, Instagram, Youtube } from 'lucide-react'
import { useClub } from '@/lib/hooks'
import { ContactForm } from '@/components/forms/ContactForm'

export function ContactPage() {
  const { data: club } = useClub()
  if (!club) return null
  return (
    <div className="py-24">
      <div className="container-narrow">
        <div className="grid gap-10 md:grid-cols-2">
          <div className="rounded-2xl border border-border bg-card p-8">
            <span className="eyebrow">Get in touch</span>
            <h1 className="mt-3 font-display text-display-3 uppercase">Contact us.</h1>
            <p className="mt-4 text-muted-foreground">Registration questions, program inquiries, sponsorship — the Cosmos office replies within one business day.</p>

            <div className="mt-8 space-y-4">
              {club.phones.map((p) => (
                <ContactRow key={p.value} icon={<Phone className="h-4 w-4" />} label={p.label} value={p.value} href={`tel:${p.value.replace(/[^0-9]/g, '')}`} />
              ))}
              {club.emails.map((e) => (
                <ContactRow key={e.value} icon={<Mail className="h-4 w-4" />} label={e.label} value={e.value} href={`mailto:${e.value}`} />
              ))}
              <ContactRow
                icon={<MapPin className="h-4 w-4" />}
                label="Address"
                value={`${club.address.line1}, ${club.address.city}, ${club.address.state} ${club.address.zip}`}
              />
            </div>

            <div className="mt-8 pt-6 border-t border-border">
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground mb-3">Follow us</div>
              <div className="flex gap-2">
                <a href={club.socials.facebook} className="grid h-10 w-10 place-items-center rounded-lg bg-muted hover:bg-cosmos-green hover:text-white transition-colors"><Facebook className="h-4 w-4" /></a>
                <a href={club.socials.instagram} className="grid h-10 w-10 place-items-center rounded-lg bg-muted hover:bg-cosmos-green hover:text-white transition-colors"><Instagram className="h-4 w-4" /></a>
                <a href={club.socials.youtube} className="grid h-10 w-10 place-items-center rounded-lg bg-muted hover:bg-cosmos-green hover:text-white transition-colors"><Youtube className="h-4 w-4" /></a>
              </div>
            </div>
          </div>

          <div className="rounded-2xl border border-border bg-card p-8">
            <span className="eyebrow eyebrow-gold">Send us a message</span>
            <h2 className="mt-3 font-display text-display-3 uppercase">Say hello.</h2>
            <div className="mt-6">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function ContactRow({ icon, label, value, href }: { icon: React.ReactNode; label: string; value: string; href?: string }) {
  const inner = (
    <div className="flex items-center gap-4">
      <div className="grid h-11 w-11 place-items-center rounded-lg bg-cosmos-green/12 text-cosmos-green">{icon}</div>
      <div>
        <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{label}</div>
        <div className="font-display text-lg tracking-wide">{value}</div>
      </div>
    </div>
  )
  return href ? <a href={href} className="hover:text-cosmos-green transition-colors block">{inner}</a> : <div>{inner}</div>
}
